import { EffectCallback, useEffect } from 'react';

function useDebouncedEffect(
    effect: EffectCallback,
    delay: number,
    deps: unknown[]
) {
    useEffect(() => {
        const timer = setTimeout(() => effect(), delay);

        return () => clearTimeout(timer);
    }, deps);
}

export default useDebouncedEffect;
